module.exports = __webpack_public_path__ + "static/media/LIDERAZGO_AUTOAGENCIA.0072a7d0.png";